<template>
  <div>
    <iframe v-if="contents" :src="contents" frameborder="0" style="width: 100%; min-height: 650px;"></iframe>
  </div>
</template>
<script>
  import utils from '@/utils'
  export default {
    created () {
      this.contents = decodeURIComponent(utils.getQueryString('url'))
    },
    watch: {
      $route (to, from) {
        this.contents = decodeURIComponent(utils.getQueryString('url'))
      }
    },
    data () {
      return {
        contents: ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/byl/org/externals/index.vue